module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('strong', [_vm._v("Table of Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_09_ch1#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 1  —  Boiler Fundamentals")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_09_ch1#lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Boilers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_09_ch1#lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boiler Components")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_09_ch1#lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Furnace")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_09_ch1#lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fans")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_09_ch1#lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Windbox")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_09_ch1#lev6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flue Gas Heat Exchangers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_09_ch1#lev7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Combustion Air Preheater")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_09_ch1#lev8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Economizer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_09_ch1#lev9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Superheater")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_09_ch1#lev10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boiler Drums")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_09_ch1#lev11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Piping and Instrument Diagrams (P&IDs)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_09_ch1#lev12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Design Basis Check List")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 2  —  Control of Boilers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#lev13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Control Strategies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#lev14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bumpless Transfer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#lev15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Simple Feedback Control")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#lev16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Feedforward plus Feedback Control")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#lev17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cascade Control")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#lev18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ratio Control")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#lev19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Feedforward Control")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#lev20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Controller Tuning")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#lev21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Determining Gain, Reset, and Derivative")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#lev22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gain vs. Proportional Band (PB)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#lev23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Controller Actions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#lev24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Controller Actions Setup")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#lev25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Effects on Tuning")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#lev26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Calibration Effect on Gain")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#lev27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Transmitters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#lev28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Redundancy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#lev29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Interlock Circuitry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#lev30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Final Control Elements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_11_ch3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 3  —  Furnace Draft")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_11_ch3#lev31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pressure Fired Boilers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_11_ch3#lev32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Balanced Draft Boiler Fans")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_11_ch3#lev33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Furnace Pressure Control")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_11_ch3#lev34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 4  —  Feedwater")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#lev35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Once-Through Boilers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#lev36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Drum Level Feedwater Control")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#lev37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Transmitters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#lev38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shrink and Swell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#lev39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Single Element Level Control")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#lev40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two Element Level Control")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#lev41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three Element Level Control")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#lev42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Control System Configuration")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#lev43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_13_ch5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 5  —  Coal Fired Boilers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_13_ch5#lev44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pulverized Coal Fired Boilers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_13_ch5#lev45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Raw Coal and Feeder")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_13_ch5#lev46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stoker Boilers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_13_ch5#lev47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cyclone Boiler")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_13_ch5#lev48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Graphics: Pulverizer Coal Boiler")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 6  —  Fuel and Air Control")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#lev49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fuel and Air Control Gas Oil")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#lev50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fuel and Air Control Characterization")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#lev51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excess Air to Oxygen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#lev52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Multiple Fuel Control")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#lev53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oxygen (O"), _c('sub', [_vm._v("2")]), _vm._v(") Trim Control")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#lev54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Multiple Boilers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_15_ch7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 7  —  Steam Temperature")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_15_ch7#lev55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three Element Level Control")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_16_ch8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 8  —  Burner Management Systems")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_16_ch8#lev56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Burner Management System (BMS) Control")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_16_ch8#lev57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NFPA 85 Code 2007")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_16_ch8#lev58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boiler Control and Operating Documentation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_16_ch8#lev59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Combustion Control")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_16_ch8#lev60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Purge Control")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_16_ch8#lev61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Requirement for Independence of Control (Hardware/Software)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_16_ch8#lev62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flame Detection")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_16_ch8#lev63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flame Monitoring and Tripping System (Multiple Burner Boilers)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_16_ch8#lev64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flame Tripping Validation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_16_ch8#lev65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Examples of Permissive Starting Logic and Protective Tripping Logic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9781937560379_17_ch9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 9  —  Environment")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_17_ch9#lev66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NO"), _c('sub', [_vm._v("x")]), _vm._v(" and NO"), _c('sub', [_vm._v("x")]), _vm._v(" Control")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_17_ch9#lev67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excess Air to Oxygen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_17_ch9#lev68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boiler Efficiency Computations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_17_ch9#lev69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Input/Output Example")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_18_ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 10 — Control Valve Sizing.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_18_ch10#lev70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Valve Characteristics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_18_ch10#lev71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Valve Characteristic Graph")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_18_ch10#lev72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recommended Velocities")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_18_ch10#lev73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Valve Sizing for Different Control Media")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_18_ch10#lev74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Control Valve Sizing Calculations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_18_ch10#lev75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gas Valve Sizing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_19_ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 11 — Steam Temperature Control")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_19_ch11#lev76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Purpose")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_19_ch11#lev77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_19_ch11#lev78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Principles and Methods of Transient Superheat Steam Temperature Control")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_19_ch11#lev79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NO"), _c('sub', [_vm._v("x")]), _vm._v(" Control")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_19_ch11#lev80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Redundancy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_19_ch11#lev81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reset Windup Prevention")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_19_ch11#lev82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Advanced Steam Temperature Control")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_20_acr#acr",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Acronyms")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_21_appa#appa",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Appendix A")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_22_appb#appb",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Appendix B")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_23_appc#appc",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Appendix C")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_24_appd#appd",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Appendix D")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_25_bib#bib",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_26_ref#ref",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("References")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_27_krapu#krapu",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Kraft Pulp Mill")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_28_ind#ind",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Index")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bbf93b36","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9781937560379_07_toc.vue
// module id = 75
// module chunks = 0